import { render, staticRenderFns } from "./ReportPromoFilter.vue?vue&type=template&id=1bac16f8"
import script from "./ReportPromoFilter.vue?vue&type=script&lang=js"
export * from "./ReportPromoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports